@if (showBanner()) {
  <section
    #panel
    id="analytics-consent"
    class="fixed z-200 inset-x-3 bottom-[max(0.75rem,env(safe-area-inset-bottom,0px))] mx-auto flex max-h-[calc(100dvh-1.5rem-env(safe-area-inset-bottom,0))] max-w-[min(100%,var(--container-xl))] flex-col overflow-hidden rounded-xl border border-ui-outline-border bg-white text-gray-900 shadow-ui-control outline-none focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-ui-primary sm:inset-x-4 sm:bottom-4 sm:max-h-[calc(100dvh-2rem)]"
    role="region"
    aria-live="polite"
    aria-labelledby="analytics-consent-title"
    [attr.aria-describedby]="describedBy()"
    tabindex="-1">
    @if (canClose()) {
      <button
        id="analytics-consent-close"
        libButton
        class="absolute top-3 right-3 z-10"
        variant="ghost"
        size="icon"
        type="button"
        [attr.aria-label]="'ANALYTICS_CONSENT.CLOSE' | translate"
        (click)="closeSettings()">
        <svg viewBox="0 0 24 24" aria-hidden="true" class="size-4">
          <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </button>
    }

    <div
      class="relative flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto overscroll-contain px-4 py-4 pb-3 sm:gap-3 sm:px-5 sm:py-5 sm:pb-3">
      <h2
        id="analytics-consent-title"
        class="m-0 text-base font-semibold leading-snug sm:text-lg"
        [class.pr-11]="canClose()">
        {{ 'ANALYTICS_CONSENT.SETTINGS' | translate }}
      </h2>

      <p id="analytics-consent-description" class="m-0 text-sm leading-normal text-gray-600 sm:text-base">
        {{ 'ANALYTICS_CONSENT.DESCRIPTION' | translate }}
        <a
          class="text-sm font-medium text-ui-primary underline underline-offset-2 rounded-sm outline-none focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-ui-primary"
          href="https://about.smallize.com/legal/privacy-policy/">
          {{ 'FOOTER.LEGAL.PRIVACY_POLICY' | translate }}
        </a>
      </p>

      @if (consent.choice(); as choice) {
        <p id="analytics-consent-status" class="m-0 flex flex-wrap items-center gap-1 text-sm text-gray-700">
          <span class="font-medium">{{ 'ANALYTICS_CONSENT.CURRENT' | translate }}:</span>
          <span libBadge size="md" [variant]="choice === 'accepted' ? 'success' : 'danger'">
            {{
              (choice === 'accepted' ? 'ANALYTICS_CONSENT.STATUS_ACCEPTED' : 'ANALYTICS_CONSENT.STATUS_REJECTED')
                | translate
            }}
          </span>
        </p>
      }
    </div>

    <div
      class="flex shrink-0 flex-col gap-3 px-4 py-3 sm:flex-row sm:flex-wrap sm:justify-end sm:border-t-0 sm:px-5 sm:py-5 sm:pt-0">
      <button
        id="analytics-consent-reject"
        libButton
        class="w-full sm:w-auto"
        [variant]="'outline'"
        size="sm"
        type="button"
        [attr.aria-pressed]="consent.choice() === null ? null : consent.choice() === 'rejected'"
        (click)="reject()">
        {{ 'ANALYTICS_CONSENT.REJECT' | translate }}
      </button>
      <button
        id="analytics-consent-accept"
        libButton
        class="w-full sm:w-auto"
        [variant]="'primary'"
        size="sm"
        type="button"
        [attr.aria-pressed]="consent.choice() === null ? null : consent.choice() === 'accepted'"
        (click)="accept()">
        {{ 'ANALYTICS_CONSENT.ACCEPT' | translate }}
      </button>
    </div>
  </section>
}
